"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.default = styled_components_1.styled.div `
  background: ${(props) => props.theme.panelOuter};
  overflow-x: ${(props) => (props.noOverflow ? "hidden" : "visible")};
  overflow-y: ${(props) => (props.noOverflow ? "hidden" : "auto")};
  border-radius: ${(props) => (props.rounded ? props.theme.radius : "0")};
  box-shadow: ${(props) => props.shineAndShadow ? props.theme.boxShadows.outerPanel : ""};
`;
//# sourceMappingURL=OuterPanel.js.map